import React from 'react';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  className = '',
  href,
  fullWidth = false
}: ButtonProps) {
  const baseClass = `inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-medium text-white transition-all duration-300 bg-[#8B7355] rounded-full hover:bg-[#7A6548] hover:shadow-xl hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#8B7355] focus:ring-offset-2 focus:ring-offset-[#FAF7F2] ${fullWidth ? 'w-full' : ''}`;
  if (href) {
    return <a href={href} className={`${baseClass} ${className}`} data-id="element-165">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={`${baseClass} ${className}`} data-id="element-166">
      {children}
    </button>;
}